/* eslint-disable react/style-prop-object */
import { FormattedNumber, useIntl } from 'react-intl';
import { IWithContextProps, useAppContext, withContext } from '@tock/coretypes';
import { PureComponent } from 'react';

interface Props {
  locale?: string;
  maximumFractionDigits?: number;
  minimumFractionDigits?: number;
  value: number;
}

export const useFormatPercentage = () => {
  const intl = useIntl();
  const { context } = useAppContext();

  return ({
    locale: localeFromProps,
    maximumFractionDigits = 3,
    minimumFractionDigits = 0,
    value,
  }: Props) => {
    const locale = localeFromProps || context.locale;
    return intl.formatNumber(isNaN(value) ? 0 : value, {
      locales: [locale],
      maximumFractionDigits,
      minimumFractionDigits,
      style: 'percent',
    });
  };
};

/**
 * Displays a percentage in the current locale.
 */
/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
class DisplayPercentage extends PureComponent<Props & IWithContextProps> {
  static defaultProps: Partial<Props> = {
    minimumFractionDigits: 0,
    maximumFractionDigits: 3,
  };

  render() {
    const {
      context: { locale: localeFromContext },
      locale: localeFromProps,
      maximumFractionDigits,
      minimumFractionDigits,
      value,
    } = this.props;

    const locale = localeFromProps || localeFromContext;

    return (
      <FormattedNumber
        locales={[locale]}
        maximumFractionDigits={maximumFractionDigits}
        minimumFractionDigits={minimumFractionDigits}
        style="percent"
        value={isNaN(value) ? 0 : value}
      />
    );
  }
}

export default withContext(DisplayPercentage);
